import { render, staticRenderFns } from "./chatwindow.vue?vue&type=template&id=56284f94&scoped=true"
import script from "./chatwindow.vue?vue&type=script&lang=js"
export * from "./chatwindow.vue?vue&type=script&lang=js"
import style0 from "./chatwindow.vue?vue&type=style&index=0&id=56284f94&prod&lang=css"
import style1 from "./chatwindow.vue?vue&type=style&index=1&id=56284f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56284f94",
  null
  
)

export default component.exports